import { Image } from "./image";
import React from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import Swiper modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export const Gallery = (props) => {
  return (
    <div id="comunhao" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Comunhão</h2>
          <b>
            <p>
              Efésios 4:2–3
              <br />
              "Com toda a humildade e mansidão, com longanimidade, suportando-vos uns aos outros em amor, esforçando-vos diligentemente por preservar a unidade do Espírito no vínculo da paz."
            </p>
          </b>
        </div>
        
        <div className="gallery-swiper-container">
          {props.data ? (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={15}
              slidesPerView={1}
              navigation={true}
              pagination={{ 
                clickable: true,
                dynamicBullets: true 
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              breakpoints={{
                576: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                992: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
              className="gallery-swiper"
            >
              {props.data.map((d, i) => (
                <SwiperSlide key={`${d.title}-${i}`}>
                  <div className="swiper-slide-content">
                    <div className="image-card">
                      <div className="image-container">
                        <Image
                          title={d.title}
                          largeImage={d.largeImage}
                          smallImage={d.smallImage}
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="loading-placeholder text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};